export default "__VITE_ASSET__BfqO7NCf__"